export default __webpack_public_path__ + "static/media/100.c50a515c.jpg";